import { gql } from '@apollo/client';

export const GET_ALL_LEND_BOOKINGS = gql`
  query AllLendToolBookings($limit: Int!, $offset: Int!) {
    currentUser {
      lendToolBookings(limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          fromDate
          toDate
          status
          totalPriceCents
          tool {
            id
            name
            primaryImageUrl
            description
          }
          bookingUser {
            id
            name
            avatarImageUrl
            reviewCount
            ratingAverage
          }
        }
      }
    }
  }
`;
